    // src/redux/slices/authSlice.js
    import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
    import axios from "axios";
    import { ApiBaseUrl, deleteAccountProfessional } from "../../Utils/Constants";
    import { showToast } from "../../Helper/Toast";

    export const hitDeleteAccountProfessionalApi = createAsyncThunk("hitDeleteAccountProfessionalApi", async () => {
      try {
        const config = {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: `${localStorage.getItem("professionalToken")}`,
          },
        };
        const url = ApiBaseUrl + deleteAccountProfessional;
        const response = await axios.put(url, {}, config);
        return response.data;
      } catch (error) {
        showToast(error.response.data.message, "error");
        throw error.response.data;
      }
    });
    
    const DeleteAccountProfessionalSlice = createSlice({
      name: "deleteAccountProfessionalReducer",
      initialState: {
        isLoading: false,
        data: null,
      },
      reducers: {
        clearhitDeleteAccountProfessionalData: (state) => {
          state.data = null;
        },
      },
      extraReducers: (builder) => {
        builder
          .addCase(hitDeleteAccountProfessionalApi.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(hitDeleteAccountProfessionalApi.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
          })
          .addCase(hitDeleteAccountProfessionalApi.rejected, (state) => {
            state.isError = false;
          });
      },
    });

    export const { clearhitDeleteAccountProfessionalData } = DeleteAccountProfessionalSlice.actions;
    export default DeleteAccountProfessionalSlice.reducer;
    